import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BusinessMetricsMetricRoute extends Route {
  @service store;
  @service router;

  model({ metric_id }) {
    return this.store.findRecord('metric', metric_id, {
      include: 'target',
    });
  }

  @action
  error(error) {
    if (error.code === 'NotFoundError') {
      this.router.replaceWith('business.metrics.list');
    } else {
      // Let the route above this handle the error.
      return true;
    }
  }
}

export default instrumentRoutePerformance(BusinessMetricsMetricRoute);
